export const APP_VERSION = '1790111624971';
